import Dashboard from '@/pages/Dashboard.vue';
import authenticated from '@/middleware/authenticated';
import team from '@/middleware/team';
import Library from '@/pages/Library.vue';
import AudioContent from '@/pages/AudioContent.vue';
import Feed from '@/pages/Feed.vue';
import Settings from '@/pages/Settings.vue';
import Users from '@/pages/Users.vue';
import Profile from '@/pages/Profile.vue';

export default [
    {
        path: '/dashboard',
        name: 'admin.dashboard',
        component: Dashboard,
        meta: { layout: 'Dashboard', middleware: [authenticated, team] }
    },
    {
        path: '/library',
        name: 'library',
        component: Library,
        meta: { layout: 'Dashboard', middleware: [authenticated, team] }
    },
    {
        path: '/audio-content',
        name: 'audio-content',
        component: AudioContent,
        meta: { layout: 'Dashboard', middleware: [authenticated, team] }
    },
    {
        path: '/feed',
        name: 'feed',
        component: Feed,
        meta: { layout: 'Dashboard', middleware: [authenticated, team] }
    },
    {
        path: '/feed/add',
        name: 'feed-add',
        component: () => import('@/pages/FeedStudio.vue'),
        meta: { layout: 'Dashboard', middleware: [authenticated, team] }
    },
    {
        path: '/profile',
        name: 'profile',
        component: Profile,
        meta: { layout: 'Dashboard', middleware: [authenticated, team] }
    },
    {
        path: '/users',
        name: 'users',
        component: Users,
        meta: { layout: 'Dashboard', middleware: [authenticated, team] }
    },
    {
        path: '/settings',
        name: 'settings',
        component: Settings,
        meta: { layout: 'Dashboard', middleware: [authenticated, team] }
    }
];
